import { FC } from "react";

function Mission() {
	return (
		<div className="text-primary flex flex-col items-center justify-center sm:mt-8">
			{/* Content container */}
			<div className="h-full flex flex-col overflow-clip sm:rounded-3xl sm:border sm:border-primary-inactive sm:max-w-[402px] mb-4">
				<UxTitle />
				<UxMascot />
				<UxMission />
				{/* Decorative flourish */}
				<div className="flex items-center justify-center py-2">
					<div className="flex-grow h-px bg-primary-inactive"></div>
					<div className="mx-4 text-primary-accent text-2xl">❖</div>
					<div className="flex-grow h-px bg-primary-inactive"></div>
				</div>
				<UxStory />
			</div>
		</div>
	);
}

const UxTitle: FC = () => {
	return (
		<div
			className="relative pt-8 pb-16 bg-cover bg-center"
			style={{ backgroundImage: "url(./headerContour.png)" }}
		>
			<h1 className="text-4xl font-bold text-primary ml-4 mb-2">Our Mission</h1>
		</div>
	);
};

const UxMascot: FC = () => {
	return (
		<div className="relative -mt-12 px-6">
			<div className="w-24 h-24 mx-auto">
				<img
					src="../mappy-icon-BW.png"
					alt="Mappy mascot"
					className="w-full object-cover"
				/>
			</div>
		</div>
	);
};

const UxMission: FC = () => {
	return (
		<div className="mt-6 px-8 pb-6 space-y-4 text-primary">
			<p>
				We empower job seekers to navigate their career journey with confidence
				and clarity, transforming the job search from a source of anxiety into
				an opportunity for growth.
			</p>
		</div>
	);
};

const UxStory: FC = () => {
	return (
		<div className="mt-6 px-8 pb-6 space-y-4 text-primary">
			<p>
				JobMap was born from grit, passion, and our simple belief that finding
				your next opportunity shouldn't feel like chaos.
			</p>
			<p>
				How it all started, when a friend asked if I could help someone just
				starting their career, I said yes. I didn't know where it would lead. I
				was about to discover a problem that affects millions of job seekers,
				just like you. Fresh from my own experience navigating a corporate
				merger and the messy reality of job searching, I was using different
				filing systems and disconnected apps. I saw an opportunity to build
				something better.
			</p>
			<p>
				What began as an effort to help just one person quickly grew into
				something bigger. Talented and passionate people began volunteering
				their time because they believed in our mission. I wasn't trying to
				build a business; I was solving real problems I'd lived through.
			</p>
			<p>
				Today we're still that same team of people who think mentoring matters
				and that the right tools can transform fear into confidence.
			</p>
		</div>
	);
};

export default Mission;
